module.exports = __webpack_public_path__ + "img/topic2-2.b975d4f3.png";